import type { Vector2 } from '../core/constants';

export interface Entity {
  id: string;
  position: Vector2;
  velocity: Vector2;
  active: boolean;

  update(deltaTime: number): void;
  destroy(): void;
}

let entityIdCounter = 0;

export function generateEntityId(prefix: string): string {
  return `${prefix}_${++entityIdCounter}`;
}
